export default class ProcessadorValorSimples {
    processar(campo) {
        return campo?.valor?.valor || campo?.valor;
    }
}
